const ANCHOR_HIGHLIGHT_CLASS = 'seo-focus-anchor';
const ANCHOR_HIGHLIGHT_MS = 2200;

export function scrollIntoViewIfNotVisible(selector: string, scrollOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'end',
    inline: 'nearest'
}): void {
    const targetEl = document.querySelector(selector);
    if (targetEl) {
        if (targetEl.getBoundingClientRect().bottom > window.innerHeight) {
            targetEl.scrollIntoView(scrollOptions);
        }

        if (targetEl.getBoundingClientRect().top < 0) {
            targetEl.scrollIntoView(scrollOptions);
        }
    }
}

export function scrollToWorkspaceAnchor(selector: string): boolean {
    const targetEl = document.querySelector(selector) as HTMLElement | null;
    if (!targetEl) {
        return false;
    }
    targetEl.style.scrollMarginTop = '88px';
    document.querySelectorAll('.' + ANCHOR_HIGHLIGHT_CLASS).forEach((el) => {
        el.classList.remove(ANCHOR_HIGHLIGHT_CLASS);
    });
    targetEl.classList.add(ANCHOR_HIGHLIGHT_CLASS);
    targetEl.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
    window.setTimeout(() => {
        targetEl.classList.remove(ANCHOR_HIGHLIGHT_CLASS);
    }, ANCHOR_HIGHLIGHT_MS);
    return true;
}

export function focusWorkspaceAnchor(selector: string, waitForExpand = false): void {
    const run = (attempt = 0): void => {
        if (scrollToWorkspaceAnchor(selector) || attempt >= 24) {
            return;
        }
        setTimeout(() => run(attempt + 1), 120);
    };
    setTimeout(() => run(), waitForExpand ? 400 : 50);
}
